export default __webpack_public_path__ + "static/media/img_bkg_Detail.d7a1cf18.jpg";